export default __webpack_public_path__ + "static/media/fullPageEdited.7db95c71.7db95c71.jpg";